import * as React from 'react';
import c from 'classnames';
import styles from './css/ClickElement.css';
import { ThemeContext } from '../commons';

//primary, secondary, tertiary
export const ClickElement = ({
  ElementType,
  text,
  primary,
  secondary,
  tertiary,
  info,
  modalclose,
  error,
  active,
  ...restProps
}) => (
  <ThemeContext.Consumer>
    {({ isNightMode }) => (
      <ElementType className={c(
        { [styles.btn]: primary || secondary || tertiary || info || modalclose || error },
        { [styles.primary]: primary },
        { [styles.secondary]: secondary },
        { [styles.tertiary]: tertiary },
        { [styles.info]: info },
        { [styles.error]: error },
        { [styles['modal-close']]: modalclose },
        { [styles.active]: active },
        { [styles.daymode]: !isNightMode },
      )}

      // testId should not appear in the DOM this attribute for react component testing
      {...Object.entries(restProps).reduce((a, [k, v]) => k === 'testId' ? a : ({ ...a, [k]: v }), {})}
      >
        {text}
      </ElementType>
    )}
  </ThemeContext.Consumer>
);
